import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["aria-label", "data-price-rule-key"]
const _hoisted_2 = ["aria-hidden"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("sup", { class: "total-note-marker" }, "**", -1 /* HOISTED */)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode(" A variable price's \"**\", alone or before text (the floating cart's and the Cart\n\t     column's note). A button opening the rules' bubble (price_rule_bubble.js,\n\t     delegated on the document) when there is a rule to show; plain text otherwise,\n\t     neither focusable nor announced as a control. The \"**\" stays out of the msgids,\n\t     as the totals' markers do. "),
    _createCommentVNode(" price_rule_bubble.js owns aria-expanded: it sets it on open and close. "),
    ($props.rules.length)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: _normalizeClass(["price-rule-trigger", { 'price-rule-note': $props.text }]),
          "aria-haspopup": "dialog",
          "aria-expanded": "false",
          "aria-controls": "ioi-price-rule-popup",
          "aria-label": $props.text ? null : _ctx.__('variable price, see rules'),
          "data-price-rule-key": $setup.key
        }, [
          _createElementVNode("sup", {
            class: "total-note-marker",
            "aria-hidden": $props.text ? 'true' : null
          }, "**", 8 /* PROPS */, _hoisted_2),
          ($props.text)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(" " + $props.text), 1 /* TEXT */)
              ], 64 /* STABLE_FRAGMENT */))
            : _createCommentVNode("v-if", true)
        ], 10 /* CLASS, PROPS */, _hoisted_1))
      : (_openBlock(), _createElementBlock("span", {
          key: 1,
          class: _normalizeClass(["price-rule-static", { 'price-rule-note': $props.text }])
        }, [
          _hoisted_3,
          ($props.text)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(" " + $props.text), 1 /* TEXT */)
              ], 64 /* STABLE_FRAGMENT */))
            : _createCommentVNode("v-if", true)
        ], 2 /* CLASS */))
  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
}